export default {
  en: {
    titleLineOne: 'Please confirm',
    titleLineTwo: 'by entering the code',
    verification: 'A message with a verification code has been sent to {{phoneNumber}}.',
    codeEntry: 'Enter the code to continue.',
    noCode: 'Didn\'t get a verification code?',
  },
};
